export function NavButtons({
  onBack,
  onNext,
  nextDisabled,
  nextLabel,
}: {
  onBack?: () => void;
  onNext: () => void;
  nextDisabled?: boolean;
  nextLabel?: string;
}) {
  return (
    <div className="row" style={{ gap: 10, marginTop: 8 }}>
      <button type="button" className="btn primary" onClick={onNext} disabled={nextDisabled}>
        {nextLabel || "Next →"}
      </button>
      {onBack && (
        <button type="button" className="btn" onClick={onBack}>
          ← Back
        </button>
      )}
    </div>
  );
}
